export default __webpack_public_path__ + "static/media/datastructure.3f22b2a2.png";